import { render } from "./CSS.vue?vue&type=template&id=53830f7e"
import script from "./CSS.vue?vue&type=script&lang=js"
export * from "./CSS.vue?vue&type=script&lang=js"

import "./CSS.vue?vue&type=style&index=0&id=53830f7e&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__